module.exports = __webpack_public_path__ + "img/view.4cb1afed.svg";